<div class="m-header">
  <button
    type="button"
    (click)="returnToHome()"
    class="b-brand"
    aria-label="Ir al panel principal"
  >
    <img
      src="assets/images/logo_manosabiertas.svg"
      alt="Clínica Manos Abiertas"
      class="logo"
    />
  </button>
  <div class="pc-h-item">
    <button
      type="button"
      class="pc-head-link head-link-secondary m-0 mobile-menu"
      [ngClass]="{ on: navCollapsed }"
      id="sidebar-hide"
      (click)="navCollapse()"
      aria-label="Contraer o ampliar menú principal"
      title="Contraer o ampliar menú principal"
    >
      <i class="ti ti-menu-2" aria-hidden="true"></i>
    </button>
  </div>
</div>
